import { useEffect, useState } from 'react'

/**
 * `value` as it stood once it stopped changing for `delayMs`. For a search box that fetches as the
 * user types: the request follows the pause, not every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timeout)
  }, [value, delayMs])

  return debounced
}
